import {Step} from '../Step/Step'
import {MaximizedCalendar} from './MaximizedCalendar'
import {MinimizedCalendar} from './MinimizedCalendar'

export const Calendar = () => {
  return (
    <Step
      title="Date"
      caption="When's your tour date?"
      thisStepCode="date"
      minimizedComponent={MinimizedCalendar}
      maximizedComponent={MaximizedCalendar}
    />
  )
}
